const img = (app, file) => `/img/apps/${app}/${file}`;
const shots = (app, n) =>
  Array.from({ length: n }, (_, i) => img(app, `shot${i + 1}.webp`));

export const CONTACT_EMAIL = "akaditasustono@gmail.com";
export const DEVELOPER_NAME = "Prieyuda Akadita S";

const apps = [
  {
    slug: "atomic",
    name: "Atomic",
    tagline: "Habit tracker with one-tap home-screen widgets",
    category: "Productivity",
    icon: img("atomic", "icon.png"),
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.northwind.atomic",
    summary:
      "Build habits and finish goals with fully customizable targets, and log progress in one tap from your home screen. No account, all offline.",
    description: [
      "Atomic is a local-first habit and goal tracker for Android. Choose Yes/No, Count, Quantity or Time habits, set flexible schedules, and log progress straight from three home-screen widget styles without opening the app.",
      "Everything stays on your device: no account, no server, no ads. Atomic is free for up to 2 habits, with a one-time Premium unlock for unlimited habits. No subscription.",
    ],
    features: [
      "Home-screen widgets (grid, list and circle) to add progress or start timers in one tap",
      "Yes/No, Count, Quantity and Time habits with at-least, at-most or exact goals",
      "Daily, weekday, every N days, weekly, monthly and one-off schedules",
      "Multiple timers at once with an ongoing notification",
      "Calendar history and forgiving streaks with skip and pause days",
      "Backup and restore your data as a JSON file",
      "Phone and tablet layouts, light and dark themes",
      "English, German, French, Hindi, Indonesian, Japanese and more",
    ],
    screenshots: Array.from({ length: 6 }, (_, i) => img("atomic", `shot${i + 1}.jpg`)),
  },
  {
    slug: "pokapoka",
    name: "Pokapoka",
    tagline: "A simple, relaxing coloring book",
    category: "Art & Design",
    icon: img("pokapoka", "icon.png"),
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.ydhnwb.pokapoka",
    summary:
      "Pick a drawing, pick a color, and tap to fill. Pokapoka is a lightweight coloring book for kids and grown-ups.",
    description: [
      "Pokapoka is a coloring book app built on a canvas. Choose from animals, flowers, dinosaurs and everyday objects, then paint them with a palette of colors.",
      "Finished a masterpiece? Save it straight to your gallery and share it with friends and family.",
    ],
    features: [
      "Animals, flowers, dinosaurs and everyday things to color",
      "Smooth canvas drawing with a color picker",
      "Clear the canvas and start over any time",
      "Save your artwork to the gallery",
      "Available in English, German, Hindi, Indonesian, Japanese, Korean and Chinese",
    ],
    screenshots: shots("pokapoka", 8),
  },
  {
    slug: "motuner",
    name: "Motuner",
    tagline: "Hex and table editor for ECU ROM images",
    category: "Tools",
    icon: img("motuner", "icon.png"),
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.northwind.xdfeditor",
    summary:
      "Open a BIN as a hex editor, optionally load a TunerPro-style XDF definition, and edit named tables and scalars on your tablet or phone.",
    description: [
      "Motuner is a native Android app, designed tablet-first, for editing ECU ROM images. It opens a BIN file as a hex editor on its own, and when you load a TunerPro-style XDF definition it adds named tables and scalars, a grid editor, multiplier edit, 2D and 3D charts, and a compare view.",
      "Edits are saved to a new file by default. Motuner never recalculates checksums and never talks to an ECU. It is intended for educational and off-road use only, and you are responsible for anything you flash.",
    ],
    features: [
      "Hex editor with go-to, search with wildcards, fill, copy/paste and a value inspector",
      "XDF overlay that colors table, axis and scalar bytes",
      "Grid table editor with range selection and multiplier edit",
      "Line, heatmap and 3D surface charts",
      "Compare against the original with revert and report export",
      "One undo/redo history shared by hex and table edits",
      "English, Indonesian, Thai, Filipino, Vietnamese and Malay",
    ],
    screenshots: shots("motuner", 5),
  },
  {
    slug: "jerzey3d",
    name: "Jerzey3D",
    tagline: "Design a jersey and preview it in 3D",
    category: "Art & Design",
    icon: img("jerzey3d", "icon.png"),
    playStoreUrl: "https://play.google.com/store/apps/details?id=com.northwind.hazzle",
    summary:
      "Pick a base color, add text, shapes and images to the front, back and sleeves, then preview the result on a 3D shirt.",
    description: [
      "Jerzey3D lets you design a custom jersey right on your phone or tablet. Change the base color, drop in curved text, shapes and your own images, and adjust size and rotation until it looks right.",
      "Preview the finished design on a 3D model with adjustable lighting, then export it to your gallery.",
    ],
    features: [
      "Edit the front, back and both sleeves",
      "Text with font size, rotation and curve",
      "Line, square, circle and star shapes",
      "Add your own images",
      "3D preview with dim, default and very bright lighting",
      "Save projects and export to the gallery",
    ],
    screenshots: [],
  },
];

export default apps;
